/**
 * @generated SignedSource<<914e181fb1e4c854ecc056aa8c1215de>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$data = {
  readonly expandButtonTextColor: string | null | undefined;
  readonly portals: ReadonlyArray<{
    readonly isFeatured: boolean | null | undefined;
    readonly portalId: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"portal_HelpCenterPortal">;
  } | null | undefined>;
  readonly visualConfig: {
    readonly titleColor: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement";
};
export type listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$key = {
  readonly " $data"?: listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$data;
  readonly " $fragmentSpreads": FragmentRefs<"listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "HelpLayoutPortalCard",
        "kind": "LinkedField",
        "name": "portals",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "portal_HelpCenterPortal"
          },
          {
            "kind": "ScalarField",
            "name": "isFeatured"
          },
          {
            "kind": "ScalarField",
            "name": "portalId"
          }
        ]
      },
      "action": "THROW",
      "path": "portals"
    },
    {
      "kind": "ScalarField",
      "name": "expandButtonTextColor"
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "titleColor"
        }
      ]
    }
  ],
  "type": "HelpLayoutPortalsListElement"
};

(node as any).hash = "f54a051de0b1e691ac7801678e0fe57d";

export default node;
